import { render, staticRenderFns } from "./editTraining.vue?vue&type=template&id=2744da9e&scoped=true&"
import script from "./editTraining.vue?vue&type=script&lang=js&"
export * from "./editTraining.vue?vue&type=script&lang=js&"
import style0 from "./editTraining.vue?vue&type=style&index=0&id=2744da9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2744da9e",
  null
  
)

export default component.exports